import styles from '../styles/Home.module.css';

export default function InitialHome() {
  return (
    <main className={styles.container} role="main" aria-labelledby="hero-heading">
      <div className={styles.hero}>
        <div className={styles.content}>
          <h1 id="hero-heading">
            India’s fastest-growing <span className="blue-span">EPC</span> company in Power Transmission and Distribution sector in India.
          </h1>
          <p className="blue-span">
            Strengthening the grid to meet the nation’s growing energy demands.
          </p>
          {/* <a href="/about/story" className={styles.cta} aria-describedby="hero-heading">
            Get to know us
          </a> */}
        </div>
      </div>
    </main>
  )
}
